import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

if (!i18n.isInitialized) {
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "cs",
      supportedLngs: ["cs", "en", "pl", "de"],
      debug: process.env.NODE_ENV?.toLowerCase() !== "production",
      interpolation: { escapeValue: false },
    });
}

export default i18n;
